import { Account } from '@/domain/usecases'
import { loadContentSearch } from '../content-search'

/**
 * Loads dependent catalog search
 * Shows full catalog for dependent users (showFullCatalog=true)
 */
export async function loadDependentCatalog(request: Request, account: Account.Model) {
  const url = new URL(request.url)

  return loadContentSearch({
    searchParams: url.searchParams,
    account: account,
    showFullCatalog: true
  })
}
